import React, { useContext } from 'react'
import {
    Box,
    Button,
    Text,
    Image,
    Flex,
    Center,
    Tooltip,
    Badge
} from '@chakra-ui/react'
import { Auth, Cache } from "aws-amplify";
import { NavLink, useNavigate } from "react-router";
import { LogoutIcon } from "../Icons/LogoutIcon"
import { StepsIndicator } from "../StepsIndicator"
import { TokenUsageBar } from '../TokenUsageBar';
import { deleteCookieString } from '../../utils/cookie';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { useBreadcrumbs } from '../../contexts/BreadcrumbProvider';
import { useStore } from "../../Store";

export const DrawerMenu = ({ isCollapsed }) => {
    const { user, publisher, userRole } = useContext(PublisherAndUserContext);
    const { addBreadcrumb } = useBreadcrumbs();
    const {bookCurrentStep, courseCurrentStep} = useStore((state) => state);
    const navigate = useNavigate()

    const logOut = async () => {
        try {
            Cache.clear();
            document.cookie = deleteCookieString(`dyn_session`);
            localStorage.clear();
            sessionStorage.clear();
            await Auth.signOut();
            navigate("/");
            window.location.reload();
        } catch (error) {
            console.log("error signing out: ", error);
        }
    };

    const routes = userRole.isOwner ? {
        homeRoutes: [
            { path: "/", title: "Home", icon: "/images/home.svg" }
        ],
        operations: [
            { path: "/createeddoc", title: "Create EdDoc", icon: "/images/document.svg" },
            { path: `/createbook/${bookCurrentStep}`, title: "Create Book", icon: "/images/book.svg" },
            { path: `/createcourse/${courseCurrentStep}`, title: "Create Course", icon: "/images/course.svg" },
            { path: "/myeddocs", title: "My EdDocs", icon: "/images/product-documents.svg" },
            { path: "/mydrafts", title: "My Drafts", icon: "/images/product-documents.svg" },
            { path: "/catalogs", title: "Catalogs", icon: "/images/catalog.svg" },
            { path: "/resources", title: "Resources", icon: "/images/gallery.svg" },
            { path: "/staff", title: "Staff", icon: "/images/staff.svg" },
            { path: "/instructors", title: "Instructors", icon: "/images/instructor.svg" },
            { path: "/storesettings", title: "Store Settings", icon: "/images/settings.svg" },
            { path: "/billing", title: "Billing", icon: "/images/billing.svg" },
        ],
        sales: [
            { path: "/manageaccount", title: "Stripe Account", icon: "/images/account.svg" },
            { path: "/payments", title: "Payments", icon: "/images/payments.svg" },
            { path: "/payouts", title: "Payouts", icon: "/images/payouts.svg" },
            { path: "/coupons", title: "Coupons", icon: "/images/coupons.svg" },
        ],
        insights: [
            { path: "/engagement", title: "Engagement", icon: "/images/gallery.svg" },
            { path: "/analytics", title: "Analytics", icon: "/images/catalog.svg" },
            { path: "/integrations", title: "Integrations", icon: "/images/integrations.svg" },
        ],
        support: [
            { path: "/help", title: "Help", icon: "/images/account.svg" },
        ]
    } : 
    userRole.isAdmin ? 
    {
        homeRoutes: [
            { path: "/", title: "Home", icon: "/images/home.svg" }
        ],
        operations: [
            { path: "/createeddoc", title: "Create EdDoc", icon: "/images/document.svg" },
            { path: `/createbook/${bookCurrentStep}`, title: "Create Book", icon: "/images/book.svg" },
            { path: `/createcourse/${courseCurrentStep}`, title: "Create Course", icon: "/images/course.svg" },
            { path: "/myeddocs", title: "My EdDocs", icon: "/images/product-documents.svg" },
            { path: "/mydrafts", title: "My Drafts", icon: "/images/product-documents.svg" },
            { path: "/catalogs", title: "Catalogs", icon: "/images/catalog.svg" },
            { path: "/resources", title: "Resources", icon: "/images/gallery.svg" },
            { path: "/staff", title: "Staff", icon: "/images/staff.svg" },
            { path: "/instructors", title: "Instructors", icon: "/images/instructor.svg" },
            { path: "/storesettings", title: "Store Settings", icon: "/images/settings.svg" },
        ],
        sales: [
            { path: "/payments", title: "Payments", icon: "/images/payments.svg" },
            { path: "/payouts", title: "Payouts", icon: "/images/payouts.svg" },
            { path: "/coupons", title: "Coupons", icon: "/images/coupons.svg" },
        ],
        insights: [
            { path: "/engagement", title: "Engagement", icon: "/images/gallery.svg" },
            { path: "/analytics", title: "Analytics", icon: "/images/catalog.svg" },
            { path: "/integrations", title: "Integrations", icon: "/images/integrations.svg" },
        ],
        support: [
            { path: "/help", title: "Help", icon: "/images/account.svg" },
        ]
    } :
    {
        homeRoutes: [
            { path: "/", title: "Home", icon: "/images/home.svg" }
        ],
        operations: [
            { path: "/createeddoc", title: "Create EdDoc", icon: "/images/document.svg" },
            { path: `/createbook/${bookCurrentStep}`, title: "Create Book", icon: "/images/book.svg" },
            { path: `/createcourse/${courseCurrentStep}`, title: "Create Course", icon: "/images/course.svg" },
            { path: "/myeddocs", title: "My EdDocs", icon: "/images/product-documents.svg" },
            { path: "/mydrafts", title: "My Drafts", icon: "/images/product-documents.svg" },
            { path: "/catalogs", title: "Catalogs", icon: "/images/catalog.svg" },
            { path: "/resources", title: "Resources", icon: "/images/gallery.svg" },
        ],
        support: [
            { path: "/help", title: "Help", icon: "/images/account.svg" },
        ]
    }

    return (
        <>
            <Box
                sx={{
                    overflowY: "auto",
                    height: "calc(100vh - 145px)",
                    padding: "20px 0"
                }}
            >
                {   userRole.isOwner ?
                        publisher?.otherInfo?.isOnBoardingCompleted && publisher?.otherInfo?.isStoreSettingComplete ?
                            <></> :
                            <NavLink to="/manageaccount" onClick={() => addBreadcrumb("OnBoarding Steps", "/manageaccount", true)} end>
                                <Center>
                                    <StepsIndicator isCollapsed={isCollapsed} publisher={publisher} />
                                </Center>
                            </NavLink> : 
                    <></>
                }
                {
                    Object.keys(routes).map((route, index) => (
                        <React.Fragment key={index}>
                            {index !== 0 && !isCollapsed && <Text p={"8px 10px"} fontSize="sm" color="#fff" opacity={0.7} textTransform="capitalize">{route}</Text>}
                            {routes[route]?.map((r, i) => (
                                <Tooltip label={r?.title} key={i} isDisabled={!isCollapsed} hasArrow bg='gray.700' placement='right-end'>
                                    <NavLink
                                        to={r?.path}
                                        onClick={() => addBreadcrumb(r?.title, r?.path, true)}
                                        end
                                        style={({ isActive }) => ({
                                            color: "rgb(255, 255, 255, 1)",
                                            background: isActive ? "rgb(255, 255, 255, 0.2)" : "transparent",
                                            display: "block",
                                            
                                        })}
                                    >
                                        <Flex p={isCollapsed ? "12px 10px" : "12px 16px"} alignItems="center" justifyContent={isCollapsed ? "center" : ""} fontWeight={600} letterSpacing="0.4px" _hover={{
                                            background: "rgb(255, 255, 255, 0.2)",
                                            color: "rgb(255, 255, 255, 1)"
                                        }}>
                                            <Image src={r?.icon} alt={r?.title} width="20px" mr={3} />
                                            {!isCollapsed && <Text fontSize="sm">{r?.title}</Text>}
                                            {(r?.title === "Staff" || r?.title === "Instructors") && !publisher.isPro && !isCollapsed ? <Badge variant="solid" colorScheme="whiteAlpha" ml={2}>
                                                Pro
                                            </Badge> : null}
                                        </Flex>
                                    </NavLink>
                                </Tooltip>
                            ))}
                        </React.Fragment>
                    ))
                }
            </Box>
            {
                !publisher.isPro && 
                <Box>
                    <Tooltip label="Upgrade To Pro" isDisabled={!isCollapsed} hasArrow bg='gray.700' placement='right-end'>            
                        <NavLink
                            to={"/pricingplan"}
                            onClick={() => addBreadcrumb("Pricing Plan", "/pricingplan", true)}
                            end
                            style={({ isActive }) => ({
                                color: "rgb(255, 255, 255, 1)",
                                background: isActive ? "rgb(255, 255, 255, 0.2)" : "transparent",
                                display: "block",
                                
                            })}
                        >
                            <Flex p={isCollapsed ? "12px 10px" : "12px 16px"} alignItems="center" justifyContent={isCollapsed ? "center" : ""} fontWeight={600} letterSpacing="0.4px" _hover={{
                                background: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 1)"
                            }}>
                                <Box className="animated-border">
                                    <Image src="/images/upgrade.svg" alt="upgrade" width="20px"/>
                                    {!isCollapsed && <Text fontSize="sm">Upgrade To Pro</Text>}
                                </Box>
                            </Flex>
                        </NavLink>
                    </Tooltip>
                </Box>
            }
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    padding: "12px 16px",
                    borderTop: "1px solid #eee",
                    display: "flex",
                    justifyContent: isCollapsed ? "center" : "space-between",
                    alignItems: "center",
                    flexDirection: "column",
                    color: "#fff"
                }}
            >
                {!isCollapsed && <TokenUsageBar id={publisher?.id} />}
                <Flex
                    justifyContent={isCollapsed ? "center" : "space-between"}
                    alignItems="center"
                    width="100%"
                >
                    <Box>
                        {!isCollapsed && <Text>{`${user.firstName} ${user.lastName}`}</Text>}
                        {!isCollapsed && <Text opacity="0.7" fontSize="xs">{userRole.isOwner ? "Owner" : userRole.isAdmin ? "Admin" : "Staff"}</Text>}
                    </Box>
                    <Button
                        variant='ghost'
                        onClick={logOut}
                        sx={{
                            padding: 0,
                            ":hover": {
                                background: "none"
                            }
                        }}
                    >
                        <LogoutIcon sx={{ width: "24px", height: "24px" }} fill="rgba(255, 255, 255, 0.4)"/>
                    </Button>
                </Flex>
            </Box>
        </>
    )
}
